import React from 'react'
import { format } from 'date-fns'

export const COLUMNS = [
  {
    // Make an expander cell
    Header: () => null, // No header
    id: 'expander', // It needs an ID
    Cell: ({ row }) => (
      // Use Cell to render an expander for each row.
      // We can use the getToggleRowExpandedProps prop-getter
      // to build the expander.
      <span {...row.getToggleRowExpandedProps()}>
        {row.isExpanded ? '➖' : '➕'}
      </span>
    ),
  },
//  {
  //  Header: 'Digit',
    //accessor: '_id',
    //disableFilters: true,
    //sticky: 'left',
  //},
  {
    Header: 'Customer Name',
    accessor: 'customerName',
  },
  {
    Header: 'Date',
    accessor: 'timestamp',
    sticky: 'left',
    Cell: ({ value }) => {
        return value ? format(new Date(value), 'dd/MM/yyyy') : ''        
    },
    //sortType: "datetime"
  },
  //{
    //Header: 'Customer Name',
    //Footer: 'Last Name',
    //accessor: 'last_name',
    //sticky: 'left',
  //},

  {
    Header: 'Status',
    //accessor: d => <select><option>{d.country}</option><option>ready</option><option>on progress</option></select>,
    accessor: 'status'
    //Cell: ({value}) => (
      //<option>  
        //<select>ready</select><select>on progress</select><select>{d.country}</select>
      //</option>
      //)
  },
  //{
    //Header: 'Responses',
    //accessor: '',
    //Cell: ({ value }) => {
      //return <button className='btn btn-outline-info'><span>N </span> Response</button>        
  //},
  //},
  //{
    //Header: 'Email',
    //Footer: 'Email',
    //accessor: 'email',
  //},
  {
    Header: 'Actions'
  }
]